import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { AboutComponent } from './features/about/about.component';
import { ContactUsComponent } from './features/contact-us/contact-us.component';
import { ProjectsComponent } from './features/projects/projects.component';
import { ServicesPageComponent } from './features/services-page/services-page.component';
import { NotfoundComponent } from './features/notfound/notfound.component';
import { authGuard } from './core/guards/auth-guard';
import { DashboardLayoutComponent } from './features/user-dashboard/layout/dashboard-layout/dashboard-layout.component';
import { adminAuthGuard } from './core/guards/admin-auth.guard';
export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    title: 'Home Page'
  },
  {
    path: 'about',
    component: AboutComponent,
    title: 'About Page'
  },
  {
    path: 'services',
    component: ServicesPageComponent,
    title: 'Services Page'
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    title: 'Contact Page'
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    title: 'Projects Page'
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/profile/profile.component').then(m => m.ProfileComponent),
    title: 'Profile Page'
  },



  // User Dashboard
  {
  path: 'dashboard',
  canActivate: [authGuard],
  component: DashboardLayoutComponent,
  children: [
    {
      path: '',
      loadComponent: () =>
        import('./features/user-dashboard/pages/dashboard-home/dashboard-home.component').then(
          m => m.DashboardHomeComponent
        ),
      title: 'Dashboard'
    },
    {
      path: 'my-investment',
      loadComponent: () =>
        import('./features/user-dashboard/pages/my-investment/my-investment.component').then(
          m => m.MyInvestmentComponent
        ),
      title: 'My Investment'
    },
    {
      path: 'investment-details/:id',
      loadComponent: () =>
        import('./features/user-dashboard/pages/investment-details/investment-details.component').then(
          m => m.InvestmentDetailsComponent
        ),
      title: 'Investment Details'
    },
    {
      path: 'projects',
      loadComponent: () =>
        import('./features/user-dashboard/pages/all-projects/all-projects.component').then(
          m => m.AllProjectsComponent
        ),
      title: 'All Projects'
    },
    {
      path: 'wallet',
      loadComponent: () =>
        import('./features/user-dashboard/pages/wallet/wallet.component').then(
          m => m.WalletComponent
        ),
      title: 'Wallet'
    },
    {
      path: 'deposit',
      loadComponent: () =>
        import('./features/user-dashboard/pages/deposit/deposit.component').then(
          m => m.DepositComponent
        ),
      title: 'Deposit'
    },
    {
      path: 'withdrawal',
      loadComponent: () =>
        import('./features/user-dashboard/pages/withdrawal/withdrawal.component').then(
          m => m.WithdrawalComponent
        ),
      title: 'Withdrawal'
    },
    {
      path: 'transaction-history',
      loadComponent: () =>
        import('./features/user-dashboard/pages/transaction-history/transaction-history.component').then(
          m => m.TransactionHistoryComponent
        ),
      title: 'Transaction History'
    },
     {
      path: 'userProfile',
      loadComponent: () =>
        import('./features/user-dashboard/pages/user-profile/user-profile.component').then(
          m => m.UserProfileComponent
        ),
      title: 'Transaction History'
    }
  ]
},
// Admin Dashboard
{
  path: 'admin-panel',
  children: [
    {
      path: '',
      redirectTo: 'login',
      pathMatch: 'full'
    },
    {
      path: 'login',
      loadComponent: () =>
        import('./features/admin-dashboard/pages/login/login.component').then(
          m => m.LoginComponent
        ),
      title: 'Admin Login'
    },
    {
      path: '',
      canActivate: [adminAuthGuard],
      loadComponent: () =>
        import('./features/admin-dashboard/layout/admin-layout/admin-layout.component').then(
          m => m.AdminLayoutComponent
        ),
      children: [
        {
          path: '',
          redirectTo: 'dashboard',
          pathMatch: 'full'
        },
        {
          path: 'dashboard',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/dashboard-home/dashboard-home.component').then(
              m => m.DashboardHomeComponent
            ),
          title: 'Admin Dashboard'
        },
        {
          path: 'projects',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/projects/projects-list/projects-list.component').then(
              m => m.ProjectsListComponent
            ),
          title: 'Projects'
        },
        {
          path: 'projects/:id',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/projects/project-details/project-details.component').then(
              m => m.ProjectDetailsComponent
            ),
          title: 'Project Details'
        },

         {
          path: 'cycles',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/cycles/cycle-list/cycle-list.component').then(
              m => m.CycleListComponent
            ),
          title: 'Projects'
        },
        {
          path: 'investments',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/investments/investments-list/investments-list.component').then(
              m => m.InvestmentsListComponent
            ),
          title: 'Investments'
        },
        {
          path: 'investment-requests',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/investments/investment-requests/investment-requests.component').then(
              m => m.InvestmentRequestsComponent
            ),
          title: 'Investment Requests'
        },
        {
          path: 'wallets',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/wallet/user-wallets/user-wallets.component').then(
              m => m.UserWalletsComponent
            ),
          title: 'User Wallets'
        },
        {
          path: 'deposit-requests',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/wallet/deposit-requests/deposit-requests.component').then(
              m => m.DepositRequestsComponent
            ),
          title: 'Deposit Requests'
        },
        {
          path: 'withdrawal-requests',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/wallet/withdrawal-requests/withdrawal-requests.component').then(
              m => m.WithdrawalRequestsComponent
            ),
          title: 'Withdrawal Requests'
        },
        {
          path: 'profit-records',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/wallet/profit-records/profit-records.component').then(
              m => m.ProfitRecordsComponent
            ),
          title: 'Profit Records'
        },
        {
          path: 'users',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/users/users-list/users-list.component').then(
              m => m.UsersListComponent
            ),
          title: 'Users'
        },
        {
          path: 'user-details',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/users/user-details/user-details.component').then(
              m => m.UserDetailsComponent
            ),
          title: 'User Details'
        },
        {
          path: 'contact-messages',
          loadComponent: () =>
            import('./features/admin-dashboard/pages/contact-messages/contact-messages-list/contact-messages-list.component').then(
              m => m.ContactMessagesListComponent
            ),
          title: 'Contact Messages'
        }
      ]
    }
  ]
},
  {
  path: 'faq',
  loadComponent: () =>
    import('./shared/components/footer/components/footer-support/components/faq/faq.component')
      .then(m => m.FaqComponent),
  title: 'FAQ'
},
{
  path: 'help-center',
  loadComponent: () =>
    import('./shared/components/footer/components/footer-support/components/help-center/help-center.component')
      .then(m => m.HelpCenterComponent),
  title: 'Help Center'
},
{
  path: 'contractor-guide',
  loadComponent: () =>
    import('./shared/components/footer/components/footer-support/components/contractor-guide/contractor-guide.component')
      .then(m => m.ContractorGuideComponent),
  title: 'Contractor Guide'
},
{
  path: 'technical-support',
  loadComponent: () =>
    import('./shared/components/footer/components/footer-support/components/technical-support/technical-support.component')
      .then(m => m.TechnicalSupportComponent),
  title: 'Technical Support'
},

{
  path: 'terms-of-use',
  loadComponent: () =>
    import('./shared/components/footer/components/footer-legal/components/terms-of-use/terms-of-use.component')
      .then(m => m.TermsOfUseComponent),
  title: 'Terms Of Use'
},
{
  path: 'privacy-policy',
  loadComponent: () =>
    import('./shared/components/footer/components/footer-legal/components/privacy-policy/privacy-policy.component')
      .then(m => m.PrivacyPolicyComponent),
  title: 'Privacy Policy'
},
{
  path: 'refund-policy',
  loadComponent: () =>
    import('./shared/components/footer/components/footer-legal/components/refund-policy/refund-policy.component')
      .then(m => m.RefundPolicyComponent),
  title: 'Refund Policy'
},
{
  path: 'disclaimer',
  loadComponent: () =>
    import('./shared/components/footer/components/footer-legal/components/disclaimer/disclaimer.component')
      .then(m => m.DisclaimerComponent),
  title: 'Disclaimer'
},
{
  path: '**',
  component: NotfoundComponent,
  title: 'NotFound'
}
];